import React, { useEffect, useState, useRef } from "react";
import { NavLink, Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import "./css/Navbar.scss";
import { AnimatePresence, motion } from "framer-motion";
import { useMediaQuery } from "react-responsive";

// Icons

import { Menu, Search, ArrowUp, ChevronRight } from "react-feather";

// Images

import Logo from "../assets/images/ic-getwell-circle.png";
import LogoMenu from "../assets/images/getwell-logo-menu.png";

const NavbarModal = ({ isMenuOpen, setIsMenuOpen }) => {
  const isDesktop = useMediaQuery({ query: "(min-width: 768px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });

  const [height, setHeight] = useState(window.innerHeight);
  const [width, setWidth] = useState(window.innerWidth);

  window.addEventListener("resize", function () {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  });

  const modalVariants = {
    hidden: {
      opacity: 0,
      pointerEvents: isMenuOpen ? "auto" : "none",
    },
    show: {
      opacity: 1,
      pointerEvents: isMenuOpen ? "auto" : "none",
      transition: {
        ease: [0.6, 0.01, -0.05, 0.95],
        duration: 0.3,
        delay: 0,
      },
    },
    exit: {
      opacity: 0,
    },
  };

  const popUpVariants = {
    hidden: {
      opacity: 0,
      top: -75,
      pointerEvents: isMenuOpen ? "auto" : "none",
      transition: {
        ease: [0.6, 0.01, -0.05, 0.95],
        duration: 0.3,
        delay: 0,
      },
    },
    show: {
      opacity: 1,
      top: 0,
      pointerEvents: isMenuOpen ? "auto" : "none",
      transition: {
        ease: [0.6, 0.01, -0.05, 0.95],
        duration: 0.6,
        delay: 0,
      },
    },
  };

  return (
    <>
      {isMobile && (
        <motion.div
          className="navbar-modal"
          style={{
            height: height - 75,
            width: width,
          }}
          variants={modalVariants}
          initial="hidden"
          animate={isMenuOpen ? "show" : ""}
          exit="exit"
        >
          <motion.div
            className="menu-popup"
            variants={popUpVariants}
            initial={isMenuOpen ? "" : "hidden"}
            animate={isMenuOpen ? "show" : ""}
          >
            <div className="menu-table">
              <div className="col col-1">
                <NavLink
                  to="/about"
                  className="menu-link"
                  state={{ index: 0 }}
                  onClick={() => {
                    setIsMenuOpen(false);
                  }}
                >
                  About
                </NavLink>
                <ul className="menu-list">
                  <li className="menu-list-item">
                    <NavLink
                      to="/about/leadership/board-of-directors"
                      state={{ index: 1 }}
                      className="menu-link-sm"
                      onClick={() => {
                        setIsMenuOpen(false);
                      }}
                    >
                      Leadership
                    </NavLink>
                  </li>
                  <li className="menu-list-item">
                    <NavLink
                      to="/about/committee/audit-committee"
                      state={{ index: 2 }}
                      className="menu-link-sm"
                      onClick={() => {
                        setIsMenuOpen(false);
                      }}
                    >
                      Committee
                    </NavLink>
                  </li>
                  <li className="menu-list-item">
                    <NavLink
                      to="/about/mission-and-vision"
                      state={{ index: 3 }}
                      className="menu-link-sm"
                      onClick={() => {
                        setIsMenuOpen(false);
                      }}
                    >
                      Mission and Vision
                    </NavLink>
                  </li>
                  <li className="menu-list-item">
                    <NavLink
                      to="/about/company-profile"
                      state={{ index: 4 }}
                      className="menu-link-sm"
                      onClick={() => {
                        setIsMenuOpen(false);
                      }}
                    >
                      Company Profile
                    </NavLink>
                  </li>
                  <li className="menu-list-item">
                    <NavLink
                      to="/about/corporate-identity-and-values"
                      state={{ index: 5 }}
                      className="menu-link-sm"
                      onClick={() => {
                        setIsMenuOpen(false);
                      }}
                    >
                      Our Corporate Identity and Values
                    </NavLink>
                  </li>
                  <li className="menu-list-item">
                    <NavLink
                      to="/about/certificate-of-authority"
                      state={{ index: 6 }}
                      className="menu-link-sm"
                      onClick={() => {
                        setIsMenuOpen(false);
                      }}
                    >
                      Certificate of Authority
                    </NavLink>
                  </li>
                  <li className="menu-list-item">
                    <NavLink
                      to="/about/certificate-of-registration"
                      state={{ index: 6 }}
                      className="menu-link-sm"
                      onClick={() => {
                        setIsMenuOpen(false);
                      }}
                    >
                      Certificate of Registration
                    </NavLink>
                  </li>
                  <li className="menu-list-item">
                    <NavLink
                      to="/about/branches"
                      state={{ index: 7 }}
                      className="menu-link-sm"
                      onClick={() => {
                        setIsMenuOpen(false);
                      }}
                    >
                      Our Branches
                    </NavLink>
                  </li>
                </ul>
              </div>
              <div className="col col-2">
                <NavLink
                  to="/procedures/emergency-availment"
                  className="menu-link"
                  onClick={() => {
                    setIsMenuOpen(false);
                  }}
                >
                  Procedures
                </NavLink>
                <ul className="menu-list">
                  <li className="menu-list-item">
                    <NavLink
                      to="/procedures/emergency-availment"
                      className="menu-link-sm"
                      onClick={() => {
                        setIsMenuOpen(false);
                      }}
                    >
                      Emergency Availment
                    </NavLink>
                  </li>
                  <li className="menu-list-item">
                    <NavLink
                      to="/procedures/out-patient-availment"
                      className="menu-link-sm"
                      onClick={() => {
                        setIsMenuOpen(false);
                      }}
                    >
                      Out-Patient Availment
                    </NavLink>
                  </li>
                  <li className="menu-list-item">
                    <NavLink
                      to="/procedures/in-patient-availment"
                      className="menu-link-sm"
                      onClick={() => {
                        setIsMenuOpen(false);
                      }}
                    >
                      In-Patient Availment
                    </NavLink>
                  </li>
                  <li className="menu-list-item">
                    <NavLink
                      to="/procedures/dental-availment"
                      className="menu-link-sm"
                      onClick={() => {
                        setIsMenuOpen(false);
                      }}
                    >
                      Dental Availment
                    </NavLink>
                  </li>
                </ul>

                <NavLink
                  to="/governance"
                  className="menu-link"
                  onClick={() => {
                    setIsMenuOpen(false);
                  }}
                >
                  Corporate Governance
                </NavLink>

                <NavLink
                  to="/providers"
                  className="menu-link"
                  onClick={() => {
                    setIsMenuOpen(false);
                  }}
                >
                  List of Providers
                </NavLink>
              </div>
              {/* <div className="col col-3">
                <NavLink
                  to="/reports"
                  className="menu-link"
                  onClick={() => {
                    setIsMenuOpen(false);
                  }}
                >
                  Reports
                </NavLink>
                <ul className="menu-list">
                  <li className="menu-list-item">
                    <HashLink
                      smooth
                      to={"/reports#incorporation"}
                      className="menu-link-sm"
                      onClick={() => {
                        setIsMenuOpen(false);
                      }}
                    >
                      Incorporation
                    </HashLink>
                  </li>
                  <li className="menu-list-item">
                    <HashLink
                      smooth
                      to={"/reports#by-laws"}
                      className="menu-link-sm"
                      onClick={() => {
                        setIsMenuOpen(false);
                      }}
                    >
                      By-Laws
                    </HashLink>
                  </li>
                  <li className="menu-list-item">
                    <HashLink
                      smooth
                      to={"/reports#afs"}
                      className="menu-link-sm"
                      onClick={() => {
                        setIsMenuOpen(false);
                      }}
                    >
                      AFS
                    </HashLink>
                  </li>
                  <li className="menu-list-item">
                    <HashLink
                      smooth
                      to={"/reports#gis"}
                      className="menu-link-sm"
                      onClick={() => {
                        setIsMenuOpen(false);
                      }}
                    >
                      GIS
                    </HashLink>
                  </li>
                  <li className="menu-list-item">
                    <HashLink
                      smooth
                      to={"/reports#stockholders-meeting"}
                      className="menu-link-sm"
                      onClick={() => {
                        setIsMenuOpen(false);
                      }}
                    >
                      Stockholder Meeting Minutes
                    </HashLink>
                  </li>
                  <li className="menu-list-item">
                    <HashLink
                      smooth
                      to={"/reports#asm"}
                      className="menu-link-sm"
                      onClick={() => {
                        setIsMenuOpen(false);
                      }}
                    >
                      ASM
                    </HashLink>
                  </li>
                  <li className="menu-list-item">
                    <HashLink
                      smooth
                      to={"/reports#acgr"}
                      className="menu-link-sm"
                      onClick={() => {
                        setIsMenuOpen(false);
                      }}
                    >
                      ACGR Scorecard
                    </HashLink>
                  </li>
                </ul>
              </div> */}

              <div className="col col-4">
                <NavLink
                  to="/corporate-social-responsibility"
                  className="menu-link"
                  onClick={() => {
                    setIsMenuOpen(false);
                  }}
                >
                  Corporate Social Responsibility
                </NavLink>

                <NavLink
                  to="/faq"
                  className="menu-link"
                  onClick={() => {
                    setIsMenuOpen(false);
                  }}
                >
                  FAQs
                </NavLink>

                <NavLink
                  to="/contact-us"
                  className="menu-link"
                  onClick={() => {
                    setIsMenuOpen(false);
                  }}
                >
                  Contact Us
                </NavLink>

                <img src={LogoMenu} alt="menu-logo" id="menuLogo" />
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}

      {isDesktop && (
        <motion.div
          className="navbar-modal"
          style={{
            height: height - 75,
            width: width,
          }}
          variants={modalVariants}
          initial="hidden"
          animate={isMenuOpen ? "show" : ""}
          exit="exit"
        >
          <motion.div
            className="menu-popup"
            variants={popUpVariants}
            initial={isMenuOpen ? "" : "hidden"}
            animate={isMenuOpen ? "show" : ""}
          >
            <div className="menu-table">
              <div className="col col-1">
                <NavLink
                  to="/about"
                  className="menu-link"
                  state={{ index: 0 }}
                  onClick={() => {
                    setIsMenuOpen(false);
                  }}
                >
                  About
                </NavLink>
                <ul className="menu-list">
                  <li className="menu-list-item">
                    <NavLink
                      to="/about/leadership/board-of-directors"
                      state={{ index: 1 }}
                      className="menu-link-sm"
                      onClick={() => {
                        setIsMenuOpen(false);
                      }}
                    >
                      Leadership
                    </NavLink>
                  </li>
                  <li className="menu-list-item">
                    <NavLink
                      to="/about/committee/audit-committee"
                      state={{ index: 2 }}
                      className="menu-link-sm"
                      onClick={() => {
                        setIsMenuOpen(false);
                      }}
                    >
                      Committee
                    </NavLink>
                  </li>
                  <li className="menu-list-item">
                    <NavLink
                      to="/about/mission-and-vision"
                      state={{ index: 3 }}
                      className="menu-link-sm"
                      onClick={() => {
                        setIsMenuOpen(false);
                      }}
                    >
                      Mission and Vision
                    </NavLink>
                  </li>
                  <li className="menu-list-item">
                    <NavLink
                      to="/about/company-profile"
                      state={{ index: 4 }}
                      className="menu-link-sm"
                      onClick={() => {
                        setIsMenuOpen(false);
                      }}
                    >
                      Company Profile
                    </NavLink>
                  </li>
                  <li className="menu-list-item">
                    <NavLink
                      to="/about/corporate-identity-and-values"
                      state={{ index: 5 }}
                      className="menu-link-sm"
                      onClick={() => {
                        setIsMenuOpen(false);
                      }}
                    >
                      Our Corporate Identity and Values
                    </NavLink>
                  </li>
                  <li className="menu-list-item">
                    <NavLink
                      to="/about/certificate-of-authority"
                      state={{ index: 6 }}
                      className="menu-link-sm"
                      onClick={() => {
                        setIsMenuOpen(false);
                      }}
                    >
                      Certificate of Authority
                    </NavLink>
                  </li>
                  <li className="menu-list-item">
                    <NavLink
                      to="/about/certificate-of-registration"
                      state={{ index: 6 }}
                      className="menu-link-sm"
                      onClick={() => {
                        setIsMenuOpen(false);
                      }}
                    >
                      Certificate of Registration
                    </NavLink>
                  </li>
                  <li className="menu-list-item">
                    <NavLink
                      to="/about/branches"
                      state={{ index: 7 }}
                      className="menu-link-sm"
                      onClick={() => {
                        setIsMenuOpen(false);
                      }}
                    >
                      Our Branches
                    </NavLink>
                  </li>
                </ul>
              </div>
              <div className="col col-2">
                <NavLink
                  to="/procedures/emergency-availment"
                  className="menu-link"
                  onClick={() => {
                    setIsMenuOpen(false);
                  }}
                >
                  Procedures
                </NavLink>
                <ul className="menu-list">
                  <li className="menu-list-item">
                    <NavLink
                      to="/procedures/emergency-availment"
                      className="menu-link-sm"
                      onClick={() => {
                        setIsMenuOpen(false);
                      }}
                    >
                      Emergency Availment
                    </NavLink>
                  </li>
                  <li className="menu-list-item">
                    <NavLink
                      to="/procedures/out-patient-availment"
                      className="menu-link-sm"
                      onClick={() => {
                        setIsMenuOpen(false);
                      }}
                    >
                      Out-Patient Availment
                    </NavLink>
                  </li>
                  <li className="menu-list-item">
                    <NavLink
                      to="/procedures/in-patient-availment"
                      className="menu-link-sm"
                      onClick={() => {
                        setIsMenuOpen(false);
                      }}
                    >
                      In-Patient Availment
                    </NavLink>
                  </li>
                  <li className="menu-list-item">
                    <NavLink
                      to="/procedures/dental-availment"
                      className="menu-link-sm"
                      onClick={() => {
                        setIsMenuOpen(false);
                      }}
                    >
                      Dental Availment
                    </NavLink>
                  </li>
                </ul>

                <NavLink
                  to="/governance"
                  className="menu-link"
                  onClick={() => {
                    setIsMenuOpen(false);
                  }}
                >
                  Corporate Governance
                </NavLink>

                <NavLink
                  to="/providers"
                  className="menu-link"
                  onClick={() => {
                    setIsMenuOpen(false);
                  }}
                >
                  List of Providers
                </NavLink>
              </div>
              {/* <div className="col col-3">
                <NavLink
                  to="/reports"
                  className="menu-link"
                  onClick={() => {
                    setIsMenuOpen(false);
                  }}
                >
                  Reports
                </NavLink>
                <ul className="menu-list">
                  <li className="menu-list-item">
                    <HashLink
                      smooth
                      to={"/reports#incorporation"}
                      className="menu-link-sm"
                      onClick={() => {
                        setIsMenuOpen(false);
                      }}
                    >
                      Incorporation
                    </HashLink>
                  </li>
                  <li className="menu-list-item">
                    <HashLink
                      smooth
                      to={"/reports#by-laws"}
                      className="menu-link-sm"
                      onClick={() => {
                        setIsMenuOpen(false);
                      }}
                    >
                      By-Laws
                    </HashLink>
                  </li>
                  <li className="menu-list-item">
                    <HashLink
                      smooth
                      to={"/reports#afs"}
                      className="menu-link-sm"
                      onClick={() => {
                        setIsMenuOpen(false);
                      }}
                    >
                      AFS
                    </HashLink>
                  </li>
                  <li className="menu-list-item">
                    <HashLink
                      smooth
                      to={"/reports#gis"}
                      className="menu-link-sm"
                      onClick={() => {
                        setIsMenuOpen(false);
                      }}
                    >
                      GIS
                    </HashLink>
                  </li>
                  <li className="menu-list-item">
                    <HashLink
                      smooth
                      to={"/reports#stockholders-meeting"}
                      className="menu-link-sm"
                      onClick={() => {
                        setIsMenuOpen(false);
                      }}
                    >
                      Stockholder Meeting Minutes
                    </HashLink>
                  </li>
                  <li className="menu-list-item">
                    <HashLink
                      smooth
                      to={"/reports#asm"}
                      className="menu-link-sm"
                      onClick={() => {
                        setIsMenuOpen(false);
                      }}
                    >
                      ASM
                    </HashLink>
                  </li>
                  <li className="menu-list-item">
                    <HashLink
                      smooth
                      to={"/reports#acgr"}
                      className="menu-link-sm"
                      onClick={() => {
                        setIsMenuOpen(false);
                      }}
                    >
                      ACGR Scorecard
                    </HashLink>
                  </li>
                </ul>
              </div> */}

              <div className="col col-4">
                <NavLink
                  to="/corporate-social-responsibility"
                  className="menu-link"
                  onClick={() => {
                    setIsMenuOpen(false);
                  }}
                >
                  Corporate Social Responsibility
                </NavLink>

                <NavLink
                  to="/faq"
                  className="menu-link"
                  onClick={() => {
                    setIsMenuOpen(false);
                  }}
                >
                  FAQs
                </NavLink>

                <NavLink
                  to="/contact-us"
                  className="menu-link"
                  onClick={() => {
                    setIsMenuOpen(false);
                  }}
                >
                  Contact Us
                </NavLink>

                <img src={LogoMenu} alt="menu-logo" id="menuLogo" />
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </>
  );
};

const Navbar = ({ setSearchProps }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const ref = useRef("");

  const isDesktop = useMediaQuery({ query: "(min-width: 1025px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });

  window.addEventListener("resize", function () {
    if (isSearchOpen) {
      setIsSearchOpen(false);
    }
  });

  const textVariants = {
    hidden: {
      y: 0,
    },
    show: {
      y: -3,
      transition: {
        ease: [0.6, 0.01, -0.05, 0.95],
        duration: 0.6,
        delay: 0,
      },
    },
  };

  const searchIconVariants = {
    initial: {
      opacity: 1,
    },
    animate: {
      opacity: 0,
    },
  };

  const searchContainerVariants = {
    hidden: {
      margin: "0%",
      width: "1.5%",
    },
    show: {
      margin: "0%",
      width: "5%",
    },
  };

  const searchInputVariants = {
    hidden: {
      opacity: 0,
      width: "0%",
      pointerEvents: "none",
    },
    show: {
      opacity: 1,
      width: "100%",
      pointerEvents: "auto",
    },
  };

  const handleSearch = (e) => {
    setSearchProps(e.currentTarget.value);
  };

  useEffect(
    (e) => {
      if (isSearchOpen) {
        document.getElementById("txtSearch").addEventListener("keyup", (e) => {
          if (e.key === "Enter") {
            handleSearch(e);
            ref.current.click();
          } else if (e.key === "Escape") {
            setIsSearchOpen(false);
          } else {
            e.preventDefault();
          }
        });
      } else {
        return;
      }
    },
    [isSearchOpen]
  );

  return (
    <>
      {isMobile && (
        <div className="navbar-outer">
          <div className="container">
            <ul>
              <li className="logo-container">
                <Link
                  to="/"
                  className="logo-link"
                  onClick={() => {
                    setIsMenuOpen(false);
                  }}
                >
                  <img src={Logo} alt="getwell-logo"></img>
                </Link>
              </li>
              <li>
                <Menu
                  onClick={() => {
                    setIsMenuOpen(!isMenuOpen);
                  }}
                  style={{ opacity: isMenuOpen ? 0 : 1, position: "absolute" }}
                />
                <ArrowUp
                  onClick={() => {
                    setIsMenuOpen(!isMenuOpen);
                  }}
                  style={{
                    opacity: isMenuOpen ? 1 : 0,
                    zIndex: 9,
                    color: "var(--secondary)",
                  }}
                ></ArrowUp>
              </li>
            </ul>
          </div>
          <AnimatePresence>
            <NavbarModal
              isMenuOpen={isMenuOpen}
              setIsMenuOpen={setIsMenuOpen}
              key={`modal${setIsMenuOpen}`}
            />
          </AnimatePresence>
        </div>
      )}
      {isTablet && (
        <div className="navbar-outer">
          <div className="container">
            <ul>
              <li className="logo-container">
                <Link
                  to="/"
                  className="logo-link"
                  onClick={() => {
                    setIsMenuOpen(false);
                  }}
                >
                  <img src={Logo} alt="getwell-logo"></img>
                </Link>
              </li>
              <li>
                <Menu
                  onClick={() => {
                    setIsMenuOpen(!isMenuOpen);
                  }}
                  style={{ opacity: isMenuOpen ? 0 : 1, position: "absolute" }}
                />
                <ArrowUp
                  onClick={() => {
                    setIsMenuOpen(!isMenuOpen);
                  }}
                  style={{
                    opacity: isMenuOpen ? 1 : 0,
                    zIndex: 9,
                    color: "var(--secondary)",
                  }}
                ></ArrowUp>
              </li>
            </ul>
          </div>
          <AnimatePresence>
            <NavbarModal
              isMenuOpen={isMenuOpen}
              setIsMenuOpen={setIsMenuOpen}
              key={`modal${setIsMenuOpen}`}
            />
          </AnimatePresence>
        </div>
      )}
      {isDesktop && (
        <div className="navbar-outer">
          <div className="container">
            <ul>
              <li className="logo-container">
                <Link
                  to="/"
                  className="logo-link"
                  onClick={() => {
                    setIsMenuOpen(false);
                  }}
                >
                  <img src={Logo} alt="getwell-logo"></img>
                </Link>
              </li>
              <motion.li variants={textVariants} whileHover="show">
                <NavLink
                  to="/"
                  className="nav-link home"
                  activeclassname="active"
                  onClick={() => {
                    setIsMenuOpen(false);
                  }}
                >
                  Home
                </NavLink>
              </motion.li>
              <motion.li variants={textVariants} whileHover="show">
                <NavLink
                  to="/about"
                  state={{
                    index: 0,
                  }}
                  className="nav-link about"
                  activeclassname="active"
                  onClick={() => {
                    setIsMenuOpen(false);
                  }}
                >
                  About
                </NavLink>
              </motion.li>

              <motion.li variants={textVariants} whileHover="show">
                <NavLink
                  to="/providers"
                  className="nav-link providers"
                  activeclassname="active"
                  onClick={() => {
                    setIsMenuOpen(false);
                  }}
                >
                  Providers
                </NavLink>
              </motion.li>
              <motion.li variants={textVariants} whileHover="show">
                <NavLink
                  to="/contact-us"
                  className="nav-link contact-us"
                  activeclassname="active"
                  onClick={() => {
                    setIsMenuOpen(false);
                  }}
                >
                  Contact Us
                </NavLink>
              </motion.li>
              {/* <motion.li variants={textVariants} whileHover='show'>
                <a
                  href='https://complaints.getwellhealthinc.com.ph/'
                  className='nav-link online-services'
                  activeclassname='active'
                  onClick={() => {
                    setIsMenuOpen(false);
                  }}
                  target="_blank"
                  rel='noopener noreferrer'
                >
                  Support
                </a>
              </motion.li> */}
              <motion.li
                className="search-container"
                variants={searchContainerVariants}
                initial={isSearchOpen ? "hidden" : ""}
                animate={isSearchOpen ? "" : "show"}
                transition={{
                  transition: {
                    ease: [0.6, 0.01, -0.05, 0.95],
                    duration: 0.3,
                    delay: 0,
                  },
                }}
              >
                <motion.div
                  className="icon-container search"
                  variants={searchIconVariants}
                  initial="initial"
                  animate={isSearchOpen ? "animate" : ""}
                >
                  <Search
                    onClick={() => {
                      setIsSearchOpen(!isSearchOpen);
                    }}
                  />
                </motion.div>
                <motion.div
                  className="icon-container back"
                  variants={searchIconVariants}
                  initial="initial"
                  animate={isSearchOpen ? "" : "animate"}
                >
                  <ChevronRight
                    onClick={() => {
                      setIsSearchOpen(!isSearchOpen);
                    }}
                  />
                </motion.div>
                <motion.input
                  placeholder="Search for Providers"
                  className="box"
                  id="txtSearch"
                  variants={searchInputVariants}
                  initial={isSearchOpen ? "" : "hidden"}
                  animate={isSearchOpen ? "show" : ""}
                  transition={{
                    transition: {
                      ease: [0.6, 0.01, -0.05, 0.95],
                      duration: 0.3,
                      delay: 0,
                    },
                  }}
                ></motion.input>
                <NavLink
                  to="/search"
                  className="nav-link search"
                  activeclassname="active"
                  onClick={() => {
                    setIsMenuOpen(false);
                  }}
                  style={{
                    display: "none",
                  }}
                  ref={ref}
                >
                  Search
                </NavLink>
              </motion.li>
              <li>
                <Menu
                  onClick={() => {
                    setIsMenuOpen(!isMenuOpen);
                  }}
                  style={{ opacity: isMenuOpen ? 0 : 1, position: "absolute" }}
                />
                <ArrowUp
                  onClick={() => {
                    setIsMenuOpen(!isMenuOpen);
                  }}
                  style={{
                    opacity: isMenuOpen ? 1 : 0,
                    zIndex: 9,
                    color: "var(--secondary)",
                  }}
                ></ArrowUp>
              </li>
            </ul>
          </div>
          <AnimatePresence>
            <NavbarModal
              isMenuOpen={isMenuOpen}
              setIsMenuOpen={setIsMenuOpen}
              key={`modal${setIsMenuOpen}`}
            />
          </AnimatePresence>
        </div>
      )}
    </>
  );
};

export default Navbar;
